/** @format */

import React from 'react';
import SuccessInfo from 'components/Info/SuccessInfo';

export const simCardInfoHelper = {
    onSuccess: (component, stateName, params, callBack) => {
        const onConfirm = () => {
            component.setState({ [stateName]: null });
        };
        component.setState(
            {
                [stateName]: (
                    <SuccessInfo onConfirm={onConfirm} confirmBtnText="general:common.ok" content="simcard:f.synchronization_request_send" />
                ),
            },
            () => callBack(params)
        );
    },
    onActivate: () => {},
};
